(() => {
  const ids = new Set(['8623867363570', '8639215304946']);
  const root = () => window.Shopify?.routes?.root || '/';
  let rulesPromise;
  let adding = false;
  let requestId = 0;
  const json = async (url, options) => {
    const response = await fetch(url, options);
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || 'Please try again.');
    return data;
  };
  const post = (path, body) => json(root() + path, {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)});
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: 'USD'}).format(value / 100);
  class BostonUpsell extends HTMLElement {
    async connectedCallback() {
      this.panel = this.querySelector('.cb-boston-card');
      this.status = this.querySelector('.cb-boston-status');
      this.styleSelect = this.querySelector('.cb-boston-style');
      this.colorSelect = this.querySelector('.cb-boston-color');
      this.sizeSelect = this.querySelector('.cb-boston-size');
      this.addButton = this.querySelector('.cb-boston-add');
      this.dismissed = false;
      try { this.dismissed = sessionStorage.getItem('cb-boston-dismissed') === '1'; } catch (_) {}
      this.addEventListener('change', event => {
        event.stopPropagation();
        if (event.target === this.styleSelect) this.fillProduct();
        else if (event.target === this.colorSelect) this.fillSizes();
        else if (event.target === this.sizeSelect) this.updateVariant();
      });
      this.querySelector('.cb-boston-dismiss').addEventListener('click', () => {
        this.dismissed = true;
        this.panel.hidden = true;
        try { sessionStorage.setItem('cb-boston-dismissed', '1'); } catch (_) {}
      });
      this.addButton.addEventListener('click', () => this.addOne());
      try {
        const data = JSON.parse(this.querySelector('[data-boston-data]').textContent);
        this.products = data.products.filter(p => p && ids.has(String(p.id))).filter(p => p.variants.some(v => v.available && v.price === 6000 && !v.requires_components));
        rulesPromise ||= json(this.dataset.rulesUrl);
        this.rules = await rulesPromise;
        if (!this.isConnected) return;
        this.styleSelect.replaceChildren(...this.products.map(p => new Option(p.id === 8623867363570 ? 'Boston — Lightweight' : 'Boston — City Collection', p.id)));
        if (this.products.length) this.fillProduct();
        this.applyCart(data.cart);
        const drawer = this.closest('cart-drawer');
        this.observer = new MutationObserver(() => {
          if (drawer.classList.contains('active') && !adding) this.refresh();
        });
        if (drawer) this.observer.observe(drawer, {attributes: true, attributeFilter: ['class']});
      } catch (_) { this.panel.hidden = true; }
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    eligible(cart) {
      if (!this.rules || cart.currency !== 'USD' || !cart.items?.length || cart.cart_level_discount_applications?.length) return false;
      let count = 0;
      for (const item of cart.items) {
        if (item.selling_plan_allocation) return false;
        if (ids.has(String(item.product_id))) return false;
        if (item.line_level_discount_allocations?.some(a => !this.rules.discountTitles.includes(a.discount_application?.title))) return false;
        const bundle = item.item_components?.length || item.parent_relationship || item.requires_components || item.has_components;
        const isEligible = !bundle && (this.rules.products.includes(String(item.product_id)) || this.rules.variants.includes(String(item.variant_id))) && item.original_price === 6000;
        if (isEligible) count += item.quantity;
      }
      if (count !== 1 && count !== 2) return false;
      const expectedDiscount = count === 1 ? 0 : 2000;
      return cart.total_discount === expectedDiscount && cart.total_price === cart.original_total_price - expectedDiscount;
    }
    applyCart(cart) {
      this.cart = cart;
      this.canOffer = this.eligible(cart);
      this.panel.hidden = this.dismissed || !this.canOffer || !this.products?.length;
      this.updateVariant();
    }
    async refresh() {
      const serial = ++requestId;
      try {
        const cart = await json(root() + 'cart.js');
        if (serial === requestId && this.isConnected) this.applyCart(cart);
      } catch (_) { this.panel.hidden = true; }
    }
    fillProduct() {
      this.product = this.products.find(p => String(p.id) === this.styleSelect.value);
      if (!this.product) return;
      this.sizeIndex = this.product.options.findIndex(o => (typeof o === 'string' ? o : o.name).toLowerCase() === 'size');
      this.colorIndex = this.product.options.findIndex(o => (typeof o === 'string' ? o : o.name).toLowerCase() === 'color');
      this.validVariants = this.product.variants.filter(v => v.price === 6000 && !v.requires_components);
      const colors = [...new Set(this.validVariants.map(v => v.options[this.colorIndex]))];
      this.colorSelect.replaceChildren(...colors.map(color => {
        const available = this.validVariants.some(v => v.options[this.colorIndex] === color && v.available);
        const option = new Option(color + (available ? '' : ' — Sold out'), color);
        option.disabled = !available;
        return option;
      }));
      const initial = this.validVariants.find(v => v.available);
      if (initial) this.colorSelect.value = initial.options[this.colorIndex];
      this.fillSizes();
    }
    fillSizes() {
      const current = this.sizeSelect.value;
      const variants = this.validVariants.filter(v => v.options[this.colorIndex] === this.colorSelect.value);
      this.sizeSelect.replaceChildren(...variants.map(v => {
        const size = v.options[this.sizeIndex];
        const option = new Option(size + (v.available ? '' : ' — Sold out'), size);
        option.disabled = !v.available;
        return option;
      }));
      const same = variants.find(v => v.available && v.options[this.sizeIndex] === current);
      const first = same || variants.find(v => v.available);
      if (first) this.sizeSelect.value = first.options[this.sizeIndex];
      this.updateVariant();
    }
    updateVariant() {
      if (!this.product) return;
      this.variant = this.validVariants.find(v => v.options[this.colorIndex] === this.colorSelect.value && v.options[this.sizeIndex] === this.sizeSelect.value);
      const available = !!this.variant?.available && this.variant.price === 6000;
      this.addButton.disabled = adding || !this.canOffer || !available;
      const image = this.querySelector('.cb-boston-image');
      const source = this.variant?.featured_image?.src || this.product.featured_image;
      if (source) image.src = source;
      image.alt = `${this.product.title} — ${this.colorSelect.value}`;
      this.querySelector('.cb-boston-availability').textContent = available ? 'Available in your selected color and size.' : 'This selection is sold out.';
    }
    render(response) {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && response.sections) drawer.renderContents(response);
    }
    async addOne() {
      if (adding || !this.variant?.available || !this.canOffer) return;
      adding = true;
      this.addButton.disabled = true;
      const requestedVariant = this.variant.id;
      const requestedHandle = this.product.handle;
      [this.styleSelect, this.colorSelect, this.sizeSelect].forEach(select => { select.disabled = true; });
      this.status.textContent = 'Checking your cart and selected hoodie…';
      let addedKey;
      let before;
      let confirmed = false;
      try {
        before = await json(root() + 'cart.js');
        if (!this.eligible(before)) throw new Error('Your cart changed. This $40 add-on is no longer available.');
        const product = await json(root() + `products/${requestedHandle}.js`);
        const selected = product.variants.find(v => v.id === requestedVariant);
        if (!selected?.available || selected.price !== 6000 || selected.requires_components) throw new Error('That selection is no longer available. Choose another color or size.');
        const response = await post('cart/add.js', {items: [{id: selected.id, quantity: 1, properties: {_cb_boston_offer: 'native_increment'}}], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname});
        addedKey = response.items?.[0]?.key || response.key;
        const after = await json(root() + 'cart.js');
        if (after.total_price - before.total_price !== 4000) {
          const rollback = await post('cart/change.js', {id: addedKey, quantity: 0, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname});
          this.render(rollback);
          addedKey = null;
          const target = document.querySelector('cb-boston-upsell');
          if (target) { target.panel.hidden = true; target.status.textContent = 'The $40 add-on could not be confirmed. It was removed; please review your cart.'; }
          return;
        }
        confirmed = true;
        this.render(response);
        const target = document.querySelector('cb-boston-upsell');
        if (target) target.status.textContent = `Boston Hoodie added. Your merchandise total increased by ${money(after.total_price - before.total_price)} to ${money(after.total_price)}. Shopify applied the existing hoodie offer.`;
      } catch (error) {
        if (addedKey && !confirmed) {
          try {
            const rollback = await post('cart/change.js', {id: addedKey, quantity: 0, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname});
            this.render(rollback);
            error.message = 'The add-on price could not be verified. The Boston Hoodie was removed; please review your cart.';
          } catch (_) {
            error.message = 'We could not verify the add-on price or restore your cart. Please review the Boston Hoodie and cart total before checkout.';
          }
        }
        const target = document.querySelector('cb-boston-upsell') || this;
        target.status.textContent = error.message || 'Unable to add this hoodie. Please review your cart.';
        if (before && !this.eligible(before)) target.panel.hidden = true;
      } finally {
        adding = false;
        [this.styleSelect, this.colorSelect, this.sizeSelect].forEach(select => { select.disabled = false; });
        const target = document.querySelector('cb-boston-upsell');
        if (target) target.updateVariant();
      }
    }
  }
  if (!customElements.get('cb-boston-upsell')) customElements.define('cb-boston-upsell', BostonUpsell);
})();
